import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createContext, useContext, useEffect, useState } from "react";
import { triggerOverrideTranslations } from "@/services/i18n";
var defaultTenantContext = {
    tenantId: "",
    setTenantId: function () { return undefined; },
    tenant: undefined,
    setTenant: function () { return undefined; },
};
export var TenantContext = createContext(defaultTenantContext);
export var applyTenantTranslationOverrides = function (settings) {
    var i18nSettings = settings === null || settings === void 0 ? void 0 : settings.i18n;
    triggerOverrideTranslations(i18nSettings);
};
export var TenantContextProvider = function (props) {
    var _a;
    var _b = useState(localStorage.getItem("selected-tenant-id") || null), tenantId = _b[0], setTenantId = _b[1];
    var setTenantIdWrapper = function (tenantId) {
        if (null === tenantId) {
            // localStorage.removeItem("selected-tenant-id")
        }
        else {
            localStorage.setItem("selected-tenant-id", tenantId);
        }
        setTenantId(tenantId);
    };
    var _c = useState(undefined), tenant = _c[0], setTenant = _c[1];
    // Overwrites translations based on the settings config
    useEffect(function () {
        applyTenantTranslationOverrides(tenant === null || tenant === void 0 ? void 0 : tenant.settings);
    }, [(_a = tenant === null || tenant === void 0 ? void 0 : tenant.settings) === null || _a === void 0 ? void 0 : _a.i18n]);
    var setTenantWrapper = function (newTenant) {
        setTenant(newTenant);
        if ((newTenant === null || newTenant === void 0 ? void 0 : newTenant.id) && newTenant.id !== tenantId) {
            setTenantId(newTenant.id);
        }
    };
    // Setup the context provider
    return (_jsx(TenantContext.Provider, { value: {
            tenantId: tenantId,
            setTenantId: setTenantIdWrapper,
            tenant: tenant,
            setTenant: setTenantWrapper,
        }, children: props.children }));
};
export var useTenantStore = function () {
    var _a = useContext(TenantContext), tenantId = _a.tenantId, setTenantId = _a.setTenantId;
    return [tenantId, setTenantId];
};
